module.exports = __webpack_public_path__ + "c73ed5259db18f667b4533670e58371e.svg";